import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE } from '../constant'

export const testFetch = (params, second = 1) => {
  console.log('params, ', params)
  // eslint-disable-next-line promise/param-names
  return new Promise((res) => {
    setTimeout(() => { res('OK') }, second * 1000)
  })
}

// 用户钱包基础信息 @token_required POST /account/walletInfo
export const fetchWalletInfo = () => {
  return request({
    url: `${SERVER_DOMAIN}/account/walletInfo`,
    data: {},
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWalletMainInfoRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWalletMainInfoResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: true
  })
}
// 绑定支付宝账号 @token_required POST
export const walletBoundAlipay = ({ alipayAccount, name }, refer = '') => {
  return request({
    url: `${SERVER_DOMAIN}/account/walletBoundAlipay`,
    data: {
      alipayAccount, name
    },
    method: 'POST',
    refer
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWalletBindAlipayAccountRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWalletBindAlipayAccountResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: true
  })
}
// 钱包提现获取短信验证码 @token_required POST /account/withdrawSms
export const fetchWithdrawSms = () => {
  return request({
    url: `${SERVER_DOMAIN}/account/withdrawSms`,
    data: {},
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWalletWithdrawVerificationCodeRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWalletWithdrawVerificationCodeResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: true
  })
}
// 钱包提现 @token_required POST /account/withdraw
export const withdraw = ({ verificationCode, amount }) => {
  return request({
    url: `${SERVER_DOMAIN}/account/withdraw`,
    data: { verificationCode, amount },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWalletWithdrawRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWalletWithdrawResponse',
    // ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: true
  })
}

// 收支明细 流水账接口
export const fetchWalletFlow = ({ flowType, pageNum, pageSize, dateMonth }) => {
  return request({
    url: `${SERVER_DOMAIN}/account/walletFlow`,
    data: {
      flowType, pageNum, pageSize, dateMonth
    },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWalletRunningCountRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWalletRunningCountResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: true
  })
}

// AI识包相似商品 POST  @token_required /aiservice/v2/similar
export const similar = (data) => {
  return request({
    url: `${SERVER_DOMAIN}/aiservice/v2/similar`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductSimilarRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductSimilarResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.AI_SERVICE,
    TOKEN_REQUIRED: true
  })
}
